export const invoices = {
  alerts: {
    errorDuplicateEntryNumber: 'You’ve already used invoice number “{{entryNumber}}”.',
    missingFcFiles_one: 'The PDF for this invoice can’t be found.',
    missingFcFiles_other: 'The PDFs for these invoices can’t be found.',
    successCreated: 'Your invoice has been created.',
    successDeleted: 'Your draft has been deleted.',
    successResendCoInvoice: 'Your invoice has been sent again.',
    successUpdated: 'Your invoice has been updated.',
  },
  breadcrumb: {
    create: 'Details',
    noTitle: 'No title',
    overview: 'Invoices',
  },
  conditionDialog: {
    title: 'Terms and conditions',
  },
  createEdit: {
    advantageSimulationModal: {
      distribution: {
        commission: {
          descriptionWithCs:
            'The fee to Creative Shelter. It’s calculated per invoice, based on <a href="https://my.creativeshelter.be/settings/plan">your current fee</a>, and deducted from the amount excluding VAT that you invoiced to your client. We take care of all the administrative hassle so you can invoice copyright and earn more at the end of the day.',
          descriptionWithCsMinimumCommissionApplied:
            'The fee to Creative Shelter. Because your invoice amount is on the low side, the minimum fee of €12.50 applies. Not sure whether you still get a net benefit out of it? Contact us and we’ll look at it together!',
          disclaimerWithCs: '',
          label: 'Creative Shelter fee',
        },
        costs: {
          descriptionWithCs:
            'We take into account costs of 20% of the total invoice amount. This is an estimate. It may be higher or lower, but it’s a realistic average.',
          descriptionWithoutCs:
            'We take into account costs of 20% of the total invoice amount. This is an estimate. It may be higher or lower, but it’s a realistic average.',
          disclaimerWithCs: '',
          disclaimerWithoutCs: '',
          label: 'Costs',
        },
        netAmount: {
          descriptionWithCs:
            'The net amount you keep when you invoice with Creative Shelter, after deducting our fee, costs, social security contributions, taxes, … See for yourself, in black and white: Creative Shelter pays off!',
          descriptionWithCsNoAdvantage:
            'By our estimate, you won’t benefit from this invoice. If you mainly or exclusively invoice non-creative services, it’s better not to send this invoice through us. Not sure? Feel free to contact us and we’ll look at it together!',
          descriptionWithoutCs:
            'The net amount you keep when you invoice without Creative Shelter, after deducting costs, social security contributions, taxes, …\nBe sure to compare: Creative Shelter pays off!',
          disclaimerWithCs: '',
          disclaimerWithoutCs: '',
          label: 'Net income',
        },
        socialContribution: {
          descriptionWithCs:
            'According to the distribution key, your invoice is split into a copyright part and a professional income part. On your professional income (after deducting the costs you declare), you’ll have to pay 20.5% social security contributions. These are the provisional contributions to your social insurance fund, through which you build up social rights.',
          descriptionWithoutCs:
            'On the full invoice amount, after deducting the costs you declare, you’ll have to pay 20.5% social security contributions. These are the provisional contributions to your social insurance fund, through which you build up social rights.',
          disclaimerWithCs:
            'The amount will be lower than without Creative Shelter, because you receive part of your income as copyright income.',
          disclaimerWithoutCs: '',
          label: 'Social security contribution',
        },
        taxes: {
          descriptionWithCs:
            'According to the distribution key, your invoice is split into a copyright part and a professional income part. You only pay personal income tax on the latter part (after deducting your costs and social security contribution).',
          descriptionWithoutCs:
            'You pay personal income tax on the full invoice amount, after deducting your costs and social security contributions. How much you pay depends on your marital status and your income. The higher your income, the more tax you pay. And since no distribution key applies, this is higher than if you invoiced with copyright.',
          disclaimerWithCs:
            'The average tax rate will be lower, since your professional income is also reduced. We assume a rate between 0% and 30% here, depending on the split of your specific invoice.',
          disclaimerWithCsNotMainOccupation:
            'You indicated that you work as a secondary occupation, and we assume you also receive income from a main occupation. To calculate the tax part, we assume a rate of 45%.',
          disclaimerWithoutCs: '',
          label: 'Taxes',
        },
        withholdingTaxes: {
          descriptionWithCs:
            'Withholding tax is a tax calculated on your copyright income. We calculate it automatically for you, deduct it and pay it to the tax authorities. You don’t need to do anything yourself, and this way you receive your copyright income correctly.\n\nWould you like to read more about it? You can do that <a href="https://knowledge.creativeshelter.be/wat-is-roerende-voorheffing-en-hoe-wordt-deze-berekend" target="_blank">here</a>!',
          disclaimerWithCs: '',
          label: 'Withholding tax',
        },
      },
      label: {
        withCs: 'With Creative Shelter',
        withoutCs: 'Without Creative Shelter',
      },
      noDataDisclaimer: 'The benefit can’t be calculated yet. Complete your invoice and make sure you’ve added at least one line.',
      title: 'Benefit simulation',
      toggle: {
        withCs: 'With Creative Shelter',
        withoutCs: 'Without Creative Shelter',
      },
      totals: {
        advantage: 'Creative Shelter benefit',
        netAmount: 'Net income',
        noAdvantage: 'No benefit',
        totalInvoiced: 'Client invoice',
      },
    },
    assignment: {
      description: 'Briefly describe what your assignment involves.',
      fieldLabel: 'Information about the assignment',
      title: 'Assignment',
    },
    attachments: {
      attachment: 'Attachment',
      description: 'Add any documents to this invoice.',
      error: {
        delete: 'Something went wrong while deleting the attachment.',
      },
      title: 'Attachments',
    },
    automaticApprovalModal: {
      automatic: 'Instant invoicing',
      description:
        'Your invoice can be approved immediately. You can still choose to have us review your invoice, but then approval takes a little longer.',
      manual: 'Approve manually',
      title: 'Instant invoicing',
    },
    basicInfo: {
      description: 'All the basic information about your invoice.',
      title: 'Basic information',
    },
    blocker: {
      leave: 'Leave without sending',
      leaveUnsaved: 'Leave without saving',
      message:
        'Are you sure you want to leave this page? Your invoice stays in edit mode until you send it again, and until then we can’t approve it.',
      messageUnsaved:
        'Are you sure you want to leave this page? Your changes have not been saved. Your invoice stays in edit mode until you send it again, and until then we can’t approve it.',
    },
    clientInfo: {
      addEmailReceiver: 'Add recipient',
      emailSelfTooltip: 'You’ve chosen to forward invoices and credit notes to your client yourself.',
      peppol: 'Sent via Peppol',
    },
    clientModal: {
      addContact: 'Add contact person',
      cancel: 'Cancel',
      confirm: 'Confirm',
      contactsLegend: 'Choose a contact person',
      emptyList: 'No clients found.',
      newClient: 'New client',
      searchPlaceholder: 'Search for a client',
      title: 'Add a client',
      typeFilter: {
        all: 'All types',
        organisation: 'Organization',
        private: 'Individual',
      },
    },
    coTooLowModal: {
      description:
        'The amount you want to invoice is too low: after our fee, you’d have nothing left.\n\nChange your invoice by increasing the amount, or send it outside the platform.',
      dismiss: 'I get it!',
      title: 'Your invoice amount is too low',
    },
    conditions: {
      customCondition: {
        description: 'Choose one of your own, tailor-made terms and conditions.',
        placeholder: 'Choose your terms and conditions',
        title: 'Custom terms and conditions',
      },
      description: 'Choose how you want to transfer your copyright to your client.',
      specialConditionsAction: 'Special conditions',
      title: 'How do you transfer your copyright?',
      tooltip: 'The custom terms and conditions are only available in Dutch for now.',
      transfer: {
        description: 'You transfer the rights to your client after the invoice has been paid.',
      },
      usageRight: {
        description: 'You grant your client a right of use, so you keep the rights.',
      },
      viewPdf: 'Review terms and conditions',
    },
    confirmation: {
      description: 'All information filled in, is your invoice complete? We’ll check it thoroughly and then approve it.',
      descriptionEdit:
        'Invoice changed, ready to send it again? As soon as you do, we can approve it. Not ready yet? Save your invoice without sending it.',
      entryNumber: {
        close: 'Close editing',
        confirm: 'Confirm change',
        creditNoteNumber: 'Credit note number',
        decrease: 'Decrease sequence number',
        edit: 'Edit sequence number',
        increase: 'Increase sequence number',
        invoiceNumber: 'Invoice number',
        prefix: 'Prefix',
        reset: 'Reset sequence number',
        serialNumber: 'Sequence number',
        suffix: 'Suffix',
        warning:
          'The numbering series makes sure your documents are numbered correctly and automatically. You’re allowed to change it, but you’re responsible for doing so.',
      },
      minCommission: 'The minimum fee of €12.50 applies to this invoice.',
      sentWithPeppol: 'Your invoice will be sent via Peppol after approval.',
      sentWithPeppolInstant: 'Your invoice will be sent via Peppol.',
      submit: {
        create: 'Yes, create invoice',
        edit: 'Yes, send invoice',
        saveAndExit: 'Save and exit',
      },
      title: 'Your invoice is being sent to us',
      titleEdit: 'Your invoice is being sent to us again',
    },
    invoiceDetails: {
      dueDate: 'Due date',
      dueDatePlaceholder: 'Select a due date',
      numberingSeriesPlaceholder: 'Choose a numbering series',
      title: 'Invoice details',
    },
    lines: {
      description: 'List the products and/or services you offer here.',
      title: 'Invoice lines',
    },
    preview: 'Preview',
    remark: {
      description: 'Comments or questions for Creative Shelter.',
      title: 'Comments',
    },
    saveAndExitDialog: {
      description: 'Your changes will be saved, but your invoice stays in edit mode. Until you send it again, we can’t approve it.',
      saveAndExit: 'Save and exit',
      send: 'Send anyway',
      title: 'Save invoice without sending?',
    },
    submit: {
      saveAndExit: 'Save and exit',
      saveSend: 'Save & send',
    },
    title: {
      create: 'Draft invoice',
      edit: 'Edit invoice',
    },
    vatExemptLimit: {
      exceeded: {
        buttonText: 'I get it!',
        description:
          'Your total turnover is more than €25,000. As a result, you can no longer use the standard VAT exemption scheme. Could you change your VAT status before you continue invoicing? You can find more information <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">here</a>.',
        title: 'Limit reached',
      },
      firstWarning: {
        buttonText: 'OK, got it!',
        description:
          'Your total turnover is approaching €25,000. Above that limit, you can no longer use the standard VAT exemption scheme. So keep a close eye on your turnover.',
        title: 'Almost at the limit',
      },
      secondWarning: {
        buttonText: 'OK, I get it!',
        description:
          'Your total turnover is approaching €25,000. To be able to use the standard VAT exemption scheme, you can’t go over it. Change your VAT status in time.',
        title: 'Limit almost reached',
      },
    },
  },
  details: {
    confirmDownloadFcInvoiceModal: {
      buttonText: 'OK, got it!',
      description: 'This invoice is only for your own accounting, so don’t forward it to your client.',
      peppol: 'You’ve already received the invoice in your Peppol inbox. You can download it again here.',
      title: 'Attention!',
    },
    confirmEditModal: {
      bodyLocked:
        'This invoice is still in edit mode, and that’s exactly why we can’t approve it yet. Done, everything completed/changed? Then don’t forget to send your invoice again.',
      bodyPending: 'This invoice is pending approval. You can still edit it, but don’t forget to send it again when you’re done.',
      confirm: 'I get it',
      title: 'Attention!',
    },
    confirmResendCoInvoiceModal: {
      confirm: 'OK, send',
      descriptionSendFromCreativeShelter: 'Your client will receive the invoice again shortly, with you in cc.',
      descriptionSendFromFreelancer:
        'You indicated that you send the invoices yourself. So you’ll receive it yourself, to email it to your client afterwards.',
      title: 'Double-check',
    },
    copyright: {
      label: 'Copyright',
      subtitle: 'Your copyright',
      viewDocument: 'Review document',
    },
    error: {
      title: 'Error loading your invoice.',
    },
    followUp: {
      modal: {
        accept: 'Start',
        addRemark: 'Add comment',
        input: {
          placeholder: 'Optional comment',
        },
        message:
          'Your client received automatic reminder emails for your invoice, but no payment followed. By starting a follow-up, we’ll contact your client personally about the payment of your invoice.\n\nMay we start this follow-up?',
        remarkMessage:
          'Do you have any extra information or a comment before we start following up on your invoice? Enter it here.\n\nOther questions? Email administratie@creativeshelter.be.',
        title: 'Start follow-up',
        titleRemark: 'Follow-up started',
      },
      start: 'Start follow-up of unpaid invoice',
    },
    history: {
      error: {
        title: 'Error loading the history.',
      },
      message: {
        Approved: {
          default: 'Approved',
          instant: 'Instantly approved',
        },
        Created: {
          default: 'Created as draft',
        },
        CreditNoteApproved: {
          default: 'Credit note approved by Creative Shelter',
        },
        CreditNoteEmailApprovedAndSent: {
          client: 'Credit note sent to your client',
          user: 'Credit note sent to your email address',
        },
        Credited: {
          default: 'Credited',
        },
        EmailApprovedAndSent: {
          client: 'Invoice sent to your client',
          user: 'Invoice sent to your email address',
        },
        EmailPaymentReminder: {
          first: 'First reminder email (automatic) sent to your client',
          second: 'Second reminder email (automatic) sent to your client',
        },
        Expired: {
          default: 'Overdue',
        },
        Finalized: {
          default: 'Sent for approval',
        },
        FollowUpContactClientByPhone: {
          default: 'Phone contact by Creative Shelter administration',
        },
        FollowUpFormalNoticeSent: {
          default: 'Formal notice drawn up and sent',
        },
        FollowUpInvoiceSentToBailiff: {
          default: 'Follow-up by the bailiff started',
        },
        FollowUpInvoiceSentToLawyer: {
          default: 'Formal notice sent by the lawyer',
        },
        FollowUpLastManualReminder: {
          default: 'Final reminder emails sent by Creative Shelter administration',
        },
        FollowUpManualReminder: {
          default: 'Reminder emails sent by Creative Shelter administration',
        },
        FollowUpStarted: {
          default: 'Payment follow-up started',
        },
        LockedByUser: {
          default: 'Put in edit mode',
        },
        PaidByClient: {
          default: 'Paid by your client',
        },
        PaidByCreativeShelter: {
          default: 'Paid to you by Creative Shelter',
        },
        PartiallyPaid: {
          default: 'Partial payment of {{amount}} received',
        },
        PeppolCoAccepted: {
          creditNote: 'Credit note accepted via Peppol by your client',
          default: 'Accepted via Peppol by your client',
        },
        PeppolCoDelivered: {
          creditNote: 'Credit note arrived in your client’s Peppol inbox',
          default: 'Arrived in your client’s Peppol inbox',
        },
        PeppolCoRefused: {
          creditNote: 'Credit note rejected via Peppol by your client',
          default: 'Rejected via Peppol by your client',
        },
        PeppolCoSent: {
          creditNote: 'Credit note sent via Peppol to your client',
          default: 'Sent via Peppol to your client',
        },
        PeppolFcAccepted: {
          creditNote: 'Credit note accepted via Peppol by you',
          default: 'Accepted via Peppol by you',
        },
        PeppolFcDelivered: {
          creditNote: 'Credit note arrived in your Peppol inbox',
          default: 'Arrived in your Peppol inbox',
        },
        PeppolFcRefused: {
          creditNote: 'Credit note rejected via Peppol by you',
          default: 'Rejected via Peppol by you',
        },
        PeppolFcSent: {
          creditNote: 'Credit note sent via Peppol to you',
          default: 'Sent via Peppol to you',
        },
      },
    },
    paymentInfo: {
      alreadyPaid: 'Already paid',
      dueDate: 'Due date',
      expectedPaidDate: 'Expected payment date',
      expectedPaidDateTooltip:
        'You receive the payment from Creative Shelter on the first working day after we’ve received the payment from your client.',
      paidDate: 'Payment date',
      partialPayment: 'Payment {{number}}',
      remaining: 'Remaining to be paid',
      status: {
        options: {
          credited: 'Credited',
          fcPaid: 'Paid out',
          notPaid: 'Outstanding',
          paid: 'Paid',
        },
      },
      transportType: {
        label: 'Delivery method',
        options: {
          Email: 'Email',
          Peppol: 'Peppol',
        },
      },
      vatExceptionallyExempt: 'Exempt',
      withholdingTax: 'Withholding tax',
    },
    paymentInfoDetail: {
      remark: {
        byAdmin: 'Comment from {{name}}.',
        byUser: 'Your comment',
      },
      types: {
        FollowUpContactClientByPhone: {
          description: 'We’re calling your client for an update on your unpaid invoice. Any news? Then we’ll let you know.',
        },
        FollowUpFormalNoticeSent: {
          description: 'A formal notice has been sent to your client. It’s sent by email and by post, to make sure it reaches them.',
        },
        FollowUpInvoiceSentToBailiff: {
          description: 'A bailiff has been appointed. They take over the file and the contact with your client.',
        },
        FollowUpInvoiceSentToLawyer: {
          description:
            'A formal notice has been sent through a partner lawyer. It’s sent by email and by post, to make sure it reaches them.',
        },
        FollowUpLastManualReminder: {
          description:
            'Your client has already received several reminders (by email and by phone), but no payment has followed yet.\n<br>\nA very last manual reminder will follow. No response or update about the payment? Then we can take extra steps.',
        },
        FollowUpManualReminder: {
          description: 'A first manual reminder has been sent to your client. As soon as there’s an update, we’ll let you know.',
        },
        FollowUpStarted: {
          description:
            'We’re following up on your unpaid invoice. We start with extra reminders and phone contact.\n<br>\nIf that doesn’t work, extra steps follow: a formal notice, a second one through our partner lawyer and possibly the bailiff (within Belgium).\n<br>\nAs soon as there’s news, we’ll let you know.',
        },
      },
    },
    split: {
      amount: 'Amount',
      amountExclVat: 'Amount (excl. VAT)',
      co: {
        description: 'Your client receives this invoice and pays Creative Shelter.',
        eyebrow: 'Invoice for your client',
        highlight: 'Your client pays',
        preview: 'View the invoice',
      },
      copyrightGroup: 'Copyright income',
      copyrightTotal: 'Total copyright (net)',
      description: 'As soon as your invoice has been approved, we automatically create 2 invoices. Here’s why:',
      fc: {
        description: 'As soon as your client pays, we transfer the professional income and copyright income to you separately.',
        download: 'Download your invoice',
        eyebrow: 'Invoice for you',
        highlight: 'You receive',
      },
      performanceGroup: 'Professional income',
      title: 'Why 2 invoices?',
      totalInclVat: 'Total (incl. VAT)',
    },
    statusInfo: {
      message: {
        Approved: {
          default: 'Your invoice has been approved and sent to your client.',
        },
        CoPaid: {
          default: 'Your client has paid the invoice. You’ll receive the payment from Creative Shelter on the next working day.',
        },
        Credited: {
          default: 'You credited this invoice.<br>Credit note number: {{creditNoteNumber}}.<br>Reason: {{creditNoteReason}}',
        },
        Expired: {
          coPartiallyPaid: 'We’ve received a partial payment from your client. You can follow the payments in detail below.',
          default:
            'Your invoice is overdue. We’ll follow it up with your client for you, according to <a href="https://knowledge.creativeshelter.be/wat-als-mijn-klant-opdrachtgever-nog-niet-betaald-heeft-op-de-vervaldag" target="_blank">our guidelines</a>.',
          followingUp:
            'Your client didn’t pay your invoice within the payment term. To obtain payment, we’ve started the necessary follow-up. You can follow every step below.',
        },
        FcPaid: {
          default: 'Your invoice has been paid out. You’ll find the payments in detail below.',
        },
        InReview: {
          default:
            'We’ve received your invoice and will approve it as soon as possible. Want to invoice even faster? <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">Find out here</a> how you can use products to invoice instantly.',
        },
        LockedByUser: {
          default:
            'Your invoice is in edit mode. This means we can’t check it, approve it or send it to your client. Could you send it again once it’s been completed/changed?',
        },
      },
      title: {
        inReview: 'Sent for approval',
        paymentFollowUp: 'Payment in follow-up',
        sentWithPeppol: 'Sent via Peppol',
      },
    },
    summary: {
      client: {
        noClient: 'No client selected.',
      },
      content: {
        noDescription: 'No description entered.',
      },
      copyright: {
        conditionsChecklist: {
          onlineCourse: {
            item1: 'You give Creative Shelter permission to make your course available to your client.',
            item2: 'Your client may view, save or print your course for their own use.',
            item3: 'Further distribution or publication is not allowed.',
          },
          rightOfUse: {
            item1: 'You remain the owner of your work.',
            item2: 'Your client gets the right to use your work as intended (e.g. to show or distribute it).',
            item3: 'This right applies without limits in duration, place and form (unless agreed otherwise).',
          },
          transfer: {
            item1: 'You transfer the rights to your work to your client.',
            item2: 'Your work may be used, edited and distributed worldwide without limits.',
            item3: 'You remain the creator, but are no longer the legal owner (unless agreed otherwise).',
          },
        },
        noConditions: 'No conditions selected.',
        notAvailable: 'Not available',
        type: {
          condition: 'Terms and conditions',
          customCondition: 'Custom terms and conditions',
        },
        viewPdf: 'View PDF',
      },
      lines: {
        noLines: 'No invoice lines added.',
      },
    },
    timeline: {
      title: 'Timeline',
    },
  },
  fields: {
    billingPeriod: {
      helpText: 'Due date <0>{{ date }}</0>',
      label: 'Payment term',
      options: {
        '15': '15 days',
        '30': '30 days',
        '45': '45 days',
        '60': '60 days',
      },
    },
    billingPeriodEndOfMonth: {
      label: 'End of month',
      tooltip: 'Calculate the payment term from the end of the month.',
    },
    brandId: {
      label: 'Trade name',
      placeholder: 'Select a trade name',
    },
    clientId: {
      add: 'Add client',
      label: 'Client',
      placeholder: 'Select a client',
    },
    condition: {
      label: 'How do you transfer your copyright?',
      link: 'Review terms and conditions',
      placeholder: 'Select a regime',
    },
    contactId: {
      add: 'Add contact person',
      placeholder: 'Select a contact person',
    },
    customAgreementId: {
      description_one:
        'You already have an ongoing agreement with {{name}}. You don’t need to do anything, we’ll automatically refer to your agreement.',
      description_other: 'You have several ongoing agreements with {{name}}. Choose which agreement this document falls under.',
      label: 'Framework agreement',
      placeholder: 'Select a framework agreement',
    },
    description: {
      label: 'Description',
      placeholder: 'Briefly describe what your assignment involves',
    },
    entryNumber: {
      label: 'Invoice number',
    },
    numberingSeriesId: {
      helpText: 'The invoice number will be <0>{{entryNumber}}</0>.',
      label: 'Numbering series',
      labelTooltip:
        'Questions about creating a numbering series? Click <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">here</a> for more information.',
      none: 'No numbering series',
      placeholder: 'Select a numbering series',
      tooltip: 'This is a preview of your invoice number. The number only becomes final when you send the invoice to us.',
      tooltipCreate:
        'A numbering series helps you number your invoices correctly and smoothly. You can create as many as you like, but one is enough. Would you like to read more about it, or do you have questions? <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">You can do that here.</a>',
    },
    orderReference: {
      label: 'Client PO number/purchase order',
      placeholder: 'Client PO number/purchase order',
    },
    remark: {
      label: 'Comments',
      placeholder: 'Any extra comment or question about your invoice for Creative Shelter? Enter it here!',
    },
    specialConditions: {
      custom: 'This document falls under our agreement dated {{date}}',
      label: 'Special conditions',
      placeholder: 'Enter any special conditions here.',
    },
    title: {
      label: 'Title',
      placeholder: 'Title',
    },
  },
  header: {
    actionBlock: {
      button: 'Create invoice',
      dropdown: {
        creditnote: 'Create credit note',
        invoiceTemplate: 'Create invoice template',
        notCreative: 'Non-creative invoice (Billit)',
      },
    },
    title: 'Invoices',
  },
  overview: {
    columns: {
      client: 'Client',
      date: 'Invoice date',
      days: 'days',
      dueDate: 'Due date',
      entryNumber: 'Invoice',
      saved: 'Benefit',
      status: {
        lockedByUserTooltip: 'Oops! This invoice is in ‘edit mode’, so we can’t approve it. Click ‘Edit invoice’ to send your invoice.',
        options: {
          Approved: 'Sent',
          CoPaid: 'Paid',
          Credited: 'Credited',
          Draft: 'Draft',
          Expired: 'Overdue',
          FcPaid: 'Paid out',
          InReview: 'Pending approval',
          LockedByUser: 'In edit mode',
        },
        sentWithPeppolTooltip: 'via Peppol',
        title: 'Status',
      },
      substatus: {
        CoPartiallyPaid: 'Partially paid',
        PaymentInFollowUp: 'Payment in follow-up',
      },
      total: 'Total (excl. VAT)',
    },
    created: {
      subtitle: 'Invoices',
    },
    createdFromTemplateTooltip: 'This invoice was created from a template.',
    emptyState: {
      completeAccount: 'Complete account',
      createInvoice: 'Create invoice',
      text: 'Create a new invoice quickly and easily. In a few steps, it’s ready to send.',
      title: 'Ready to create your first invoice?',
    },
    error: {
      title: 'Error loading your invoices.',
    },
    lockedByAdmin: {
      description: 'Invoice number {{number}} can no longer be edited because we’re already approving it.',
      title: 'Invoice can’t be edited.',
    },
    rowActions: {
      advantage: 'View benefit',
      credit: 'Credit',
      details: 'More details',
      download: 'Download',
      duplicate: 'Copy',
      edit: {
        error: 'Something went wrong while opening the invoice. Please try again later.',
        label: 'Edit',
      },
      preview: 'View client invoice',
      resendCoInvoice: 'Resend',
    },
  },
};
